import { Query } from 'database-ql/dist/commonjs/query'

/**
 * WithArg
 * @author LL
 * @date 2022-01-19 下午 04:48
 **/
export class WithArg {
    query: Query
    localField: string
    foreignField: string
    as?: string
}
